import L from "leaflet";
import type { SourceFactory } from "./types";

export const tileSource: SourceFactory = (entry, context) => {
  const tile = entry.tile;

  if (tile === null || tile.url.length === 0) return null;

  const pane = context.paneFor(entry);
  const layer = L.tileLayer(tile.url, {
    subdomains: tile.subdomains,
    attribution: tile.attribution,
    minZoom: tile.minZoom,
    maxZoom: tile.maxZoom,
    maxNativeZoom: tile.maxNativeZoom,
    tileSize: tile.tileSize,
    detectRetina: tile.detectRetina,
    zIndex: context.zIndexFor(entry),
    pane
  });

  return {
    entry,
    kind: "tile",
    layer,
    pane,
    bounds: () => null,
    features: null,
    info: null,
    legend: () => entry.legend,
    setOpacity: value => layer.setOpacity(value),
    dispose: () => layer.remove()
  };
};
